jQuery(document).ready(function(){
 	setContentHeight();	
});

jQuery(window).resize(function() {

    setContentHeight();
	

});



function setContentHeight(){
    if( jQuery( "body" ).length ) {
     	var windowHeightSP = jQuery(window).height();
    
    	jQuery('body').css({height: 'auto'});
    	jQuery('html').css({height: 'auto'});
    	jQuery('#main-wrapper').css({height: 'auto'});
     	var bodyHeight = jQuery('body').outerHeight();
     	var mainContentSP = jQuery('#main-wrapper').outerHeight();

        if (windowHeightSP > bodyHeight){
    
     	    var newMainContentHeightSP = (windowHeightSP - bodyHeight) + mainContentSP;
    
            jQuery('#main-wrapper').css('min-height', newMainContentHeightSP + 'px');
    
        }
    }    
}